module.exports = __webpack_public_path__ + "img/title2.9b3ee53c.png";